'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { useNavigate } from "react-router-dom";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { BsFillEnvelopeFill } from "react-icons/bs";
import { BsFillTelephoneFill } from "react-icons/bs";
import { API_URL } from "../../config";

export function PhysicianCreateForm(): React.JSX.Element {
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [Rol, setRol] = useState([]);
    const [prod, setProd] = useState([]);
    const [groupError, setgroupError] = useState(false);
    const [userData, setUserData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [value, setValue] = React.useState<Option | null>(null);
    const [mail, setMail] = useState('');
    const [phone, setPhone] = useState('');
    const [Nume_prenume, setNume_prenume] = useState("");
    const [Login, setLogin] = useState("");
    const [roleError, setRoleError] = useState(false);
    const [nameError, setnameError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [defaultOption, setDefaultOption] = useState("");  // Default value should be speciality_id
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const [isActive, setIsActive] = useState(false);
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };
    //const token = getJwtFromCookies();

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/speciality`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setRol(response.data);
                // //////////////////////////////console.log(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/institutions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setProd(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/adressinstitutions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setUserData(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    interface Role {
        speciality_id: number;
        description: string;
    }

    const dropdownOptions = Rol.map((role: Role) => ({
        value: role.speciality_id,
        label: role.description
    }));

    const _onSelect = (selectedOption) => {
        //////////////////////////////console.log(selectedOption);
        setDefaultOption(selectedOption);  // Set the selected option
    };

    interface Option {
        id: number;
        inst: string;
        adres: string;
    }

    const dropdownOptions1 = prod.map((role: Option) => ({
        value: role.id,
        label: role.inst
    }));

    const organizerOptions: Option[] = userData.map((role: Option) => ({
        id: role.id,
        inst: role.inst,
        adres: role.adres,
    }));

    interface OptionUser {
        adress_id: number;
        adres: string;
        institution_id: number;
    }
    const organizerOptionsuser: OptionUser[] = userData.map((role: OptionUser) => ({
        adress_id: role.adress_id,
        adres: role.adres,
        institution_id: role.institution_id
    }));

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const handleChangelog = (e) => {
        setLogin(e.target.value);
    };

    const handleChangem = (e) => {
        const email = e.target.value;
        setMail(email);

        // Validarea email-ului cu regex
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9.-]+$/;
        if (!emailRegex.test(email)) {
            setEmailError(true);  // Setează eroarea
        } else {
            setEmailError(false);  // Șterge eroarea dacă este valid
        }
    };

    const handleChangep = (e) => {
        const value = e.target.value;
        if (/^\d{0,10}$/.test(value)) {
            setPhone(value);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (Nume_prenume === "" || defaultOption === "" || value === null) {
            setnameError(Nume_prenume === "" ? true : false)
            setRoleError(defaultOption === "" ? true : false)
            setgroupError(value === null ? true : false)
            return;
        }
        let allRequestsSuccessful = true;
        setIsLoading(true);
        try {
            const phoneNumber = Number(phone);
            await axios.post(`${API_URL}/api/physician`, {
                user_name_surname: Nume_prenume,
                phone: phoneNumber || '',
                email: mail || '',
                birth: Login || null,
                data_acord: isActive ? 1 : 0
            });

        } catch (error) {
            console.error(error);
            allRequestsSuccessful = false;
        }

        const response = await axios.get(`${API_URL}/api/physician`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
        const institutionId = response.data.find((i) => i.user_name_surname === Nume_prenume).physician_id;

        try {
            if (value) {
                await axios.post(`${API_URL}/api/physiciansinstitute`, {
                    institution_id: value.id, speciality_id: defaultOption, physician_id: institutionId
                });
            } else {
            }
        } catch (error) {
            console.error(error);
            allRequestsSuccessful = false;
        }

        if (allRequestsSuccessful) {
            handleClose();
            setIsLoading(false); // Re-enable the button after operation completes
            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } else {
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleClose = () => {
        navigate(-1); // Use navigate to go back
    };

    const handleClick = () => {
        setIsActive(!isActive);
    }

    const isDarkMode = document.documentElement.classList.contains('dark');

    return (
        <div >
            {showGrid ? (
                <div className="flex flex-row gap-2">
                    <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                    <div className="flex flex-col gap-2">
                        <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                    </div>
                </div>
            ) : (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}
                >
                    <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                        <CardHeader
                            subheader="Informatia poate fii modificata"
                            title="Profile"
                            subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                            action={
                                <button
                                    className={`px-4 py-2 rounded-md text-sm font-semibold ${isActive === true
                                        ? "bg-green-700 text-white"
                                        : "bg-gray-500 text-white"
                                        }`}
                                    onClick={handleClick}
                                >
                                    {isActive === true ? "Acord Date: Afirmativ" : "Acord Date: Negativ"}
                                </button>
                            }
                        />
                        <Divider className="dark:bg-gray-400" />
                        <CardContent>

                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Nume Prenume
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="firstName"
                                        placeholder="Nume Prenume"
                                        value={Nume_prenume}
                                        onChange={handleChange}
                                        required
                                    />
                                    {nameError && <p className="text-red-500 text-sm">Numele este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Data de nastere
                                    </label>
                                    <input
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 `}
                                        type="date"
                                        name="login"
                                        placeholder="Data de nastere"
                                        value={Login}
                                        onChange={handleChangelog}
                                    />
                                </div>

                                <div className="relative">
                                    <label
                                        className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                    >
                                        Numar de telefon
                                    </label>
                                    <BsFillTelephoneFill className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                                    <input
                                        className="pl-10 w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500"
                                        type="text"
                                        name="phone"
                                        // value={phone.formatted || ''}
                                        value={phone || ''}
                                        placeholder="+373..."
                                        onChange={handleChangep}
                                        maxLength={9}
                                    />

                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100">
                                        Posta electronica
                                    </label>
                                    <BsFillEnvelopeFill className="absolute left-3 top-6 transform -translate-y-1/2 text-gray-400" />
                                    <input
                                        className={`pl-10 w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${emailError ? 'border-red-500' : ''}`}
                                        type="text"
                                        name="email"
                                        placeholder="Posta@electronica.com"
                                        value={mail}
                                        onChange={handleChangem}
                                    />
                                    {emailError && <p className="text-red-500 text-sm">Email invalid! Trebuie să conțină @ și un domeniu valid (ex: .com sau .ru).</p>}
                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800">Specialitatea</label>
                                    <select
                                        className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${roleError ? 'border-red-500' : ''}`}  // Adaugă clasa pentru eroare
                                        value={defaultOption}
                                        onChange={(e) => _onSelect(e.target.value)}
                                    >
                                        <option value="" disabled>Alege specialitatea</option>
                                        {dropdownOptions.map((option) => (
                                            <option key={option.value} value={option.value}>{option.label}</option>
                                        ))}
                                    </select>
                                    {roleError && <p className="text-red-500 text-sm">Specialitatea este obligatorie.</p>}
                                </div>

                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Alege institutia
                                    </label>

                                    <Select
                                        options={organizerOptions}
                                        placeholder="Select institutia..."
                                        classNamePrefix="react-select"
                                        value={value}
                                        onChange={(selected) => setValue(selected as Option | null)}
                                        getOptionLabel={(e) => {
                                            return `${e.inst} - ${e.adres}`;
                                        }
                                        }
                                        getOptionValue={(e) => String(e.id)}
                                        menuPortalTarget={document.body}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.5rem',
                                                borderRadius: '0.375rem',
                                                borderColor: groupError ? 'red' : '#424242',
                                                boxShadow: 'none',
                                                height: '3rem',
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                                color: isDarkMode ? 'black' : base.backgroundColor,
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })
                                        }}
                                    />
                                    {groupError && <p className="text-red-500 text-sm">Institutia este obligatorie.</p>}

                                </div>
                            </div>

                        </CardContent>
                        <Divider className="dark:bg-gray-400" />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <button className={`btn ${isLoading
                                ? "bg-gray-500 text-gray-300"
                                : "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
                                }`}
                                onClick={handleSubmit}
                                disabled={isLoading}
                            >
                                {isLoading ? (
                                    <svg
                                        className="animate-spin fill-current shrink-0 xs:hidden"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <circle
                                            className="opacity-25"
                                            cx="8"
                                            cy="8"
                                            r="7"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                        />
                                        <path
                                            className="opacity-75"
                                            d="M12 2a6 6 0 000 12V2z"
                                        />
                                    </svg>
                                ) : (
                                    <svg
                                        className="fill-current shrink-0 xs:hidden"
                                        width="16"
                                        height="16"
                                        viewBox="0 0 16 16"
                                    >
                                        <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                    </svg>
                                )}
                                <span className="//max-xs:sr-only">
                                    {isLoading ? "Saving..." : "Salveaza detaliile"}
                                </span>
                            </button>
                        </CardActions>
                    </Card>
                </form>
            )}
        </div>
    );
}
